// A lesson's walkthrough runs in the real app, not inside the Academy. The
// Academy is its own page (no sidebar, its own top nav), so "Start the
// walkthrough" opens the app in a NEW TAB at the tour's start route with
// `?tour=<id>`; `TutorialProvider` (mounted in Dashboard) reads that param on
// load, starts the tour, and strips it from the URL. The lesson stays open in
// the original tab so the officer can read along.
import { getTutorialById } from "../tutorials";
import { TOUR_QUERY_PARAM } from "../tutorials/helpers";

/** Whether a lesson's tour exists in the build (a typo'd `tourId` never does). */
export const walkthroughAvailable = (tourId: string | undefined): boolean => Boolean(tourId && getTutorialById(tourId));

/** The in-app URL that starts `tourId` as soon as the app has loaded. */
export function walkthroughUrl(tourId: string): string {
  const tour = getTutorialById(tourId);
  const route = tour?.startRoute ?? (typeof tour?.triggerRoute === "string" ? tour.triggerRoute : "/cases");
  const params = new URLSearchParams({ [TOUR_QUERY_PARAM]: tourId });
  return `${route}?${params.toString()}`;
}

/** Open the app in a new tab with the walkthrough queued. */
export function openWalkthrough(tourId: string): void {
  const url = walkthroughUrl(tourId);
  // Not `noopener` in the features string: that makes window.open return
  // null by spec, which is indistinguishable from a blocked popup. Open
  // plainly (same origin, so an opener is harmless) and cut the link after.
  const win = window.open(url, "_blank");
  if (win) {
    try {
      win.opener = null;
    } catch {}
    return;
  }
  // Popup blocked (or no window.open): fall back to the same tab so the
  // button never does nothing.
  window.location.assign(url);
}
